import React from "react";
import DefaultProps from "./default-props";
import Rectangle from "./rectangle";

const RectangleShapeComponent = (props) => {
  return <Rectangle {...props} />;
}

RectangleShapeComponent.defaultProps = DefaultProps;

export default RectangleShapeComponent;